import React from 'react';
import { useForm } from 'react-hook-form';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.min.css';
import './contactForm.css';

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const toastifySuccess = () => {
    toast('Form sent!', {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      className: 'submit-feedback success',
      toastId: 'notifyToast'
    });
  };

  const onSubmit = async (data) => {
    try {
      const templateParams = {
        name: data.name,
        email: data.email,
        subject: data.subject,
        message: data.message
      };

      await emailjs.send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_USER_ID
      );

      reset();
      toastifySuccess();
    } catch (error) {
      console.error('EmailJS Error:', error);
    }
  };

  return (
    <div className="ContactForm">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <div className="contactForm container">
            
              <form id="contact-form" onSubmit={handleSubmit(onSubmit)} noValidate>
                {/* Row 1: Name and Email */}
                <div className="row formRow">
                
                  <div className="col-6">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      id="name"
                      {...register('name', {
                        required: 'Please enter your name',
                        maxLength: {
                          value: 30,
                          message: 'Please use 30 characters or less'
                        }
                      })}
                      className="form-control formEntry"
                      placeholder="Name"
                    />
                    {errors.name && (
                      <span className="errorMessage">{errors.name.message}</span>
                    )}
                  </div>

                  <div className="col-6">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      {...register('email', {
                        required: 'Email is required',
                        pattern: {
                          value:
                            /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                          message: 'Please enter a valid email address'
                        }
                      })}
                      className="form-control formEntry"
                      placeholder="Email address"
                    />
                    {errors.email && (
                      <span className="errorMessage">{errors.email.message}</span>
                    )}
                  </div>
                </div>

                {/* Row 2: Subject */}
                <div className="row formRow">
                  <div className="col">
                    <label htmlFor="subject">Subject</label>
                    <input
                      type="text"
                      id="subject"
                      {...register('subject', {
                        required: 'Please enter a subject',
                        maxLength: {
                          value: 75,
                          message: 'Subject cannot exceed 75 characters'
                        }
                      })}
                      className="form-control formEntry"
                      placeholder="Subject"
                    />
                    {errors.subject && (
                      <span className="errorMessage">{errors.subject.message}</span>
                    )}
                  </div>
                </div>

                {/* Row 3: Message */}
                <div className="row formRow">
                  <div className="col">
                    <label htmlFor="message">Message</label>
                    <textarea
                      rows={3}
                      id="message"
                      {...register('message', {
                        required: 'Please enter a message'
                      })}
                      className="form-control formEntry"
                      placeholder="Message"
                    />
                    {errors.message && (
                      <span className="errorMessage">{errors.message.message}</span>
                    )}
                  </div>
                </div>

                <button className="submit" type="submit">
                  Submit
                </button>
              </form>
            </div>
            <ToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
